
interface Commission {
  student_name: string;
  enrollment_date: string;
  commission_amount: number;
}

interface CommissionDetailsProps {
  details: Commission[] | null;
}

export function CommissionDetails({ details }: CommissionDetailsProps) {
  if (!details || details.length === 0) {
    return null;
  }

  return (
    <div className="mt-2 space-y-2 text-sm">
      {details.map((commission, index) => (
        <div key={index} className="border-l-2 border-blue-200 pl-2">
          <p className="font-medium">{commission.student_name}</p>
          <div className="text-muted-foreground space-y-1">
            <p>วันที่ซื้อคอร์ส: {commission.enrollment_date || 'ไม่ระบุ'}</p>
            <p className="text-blue-600">
              คอมมิชชั่น: {typeof commission.commission_amount === 'number' ? commission.commission_amount.toLocaleString() : '0'} บาท
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
